<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">
                                {{'header.assign-venue.titleList.AllAssignVenueRecords' | translate}}</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">{{'header.assign-venue.titleList.AssignVenueData' |
                                    translate}}</li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                    (click)="addnewrecord('true')">
                                    {{'header.assign-venue.titleList.AddNewRecord' | translate}}
                                </button>
                                <!-- <button type="button"
                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn-default btn-lg" (click)="
                                        download()">
                                    <i class="fe fe-download-cloud me-2"></i> {{'header.enrollment.titleList.DownloadReport' | translate}}
                                </button>
                                <button mat-button [matMenuTriggerFor]="menu" type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">
    
                                    <i class="fe fe-filter me-2"></i> Doc Type
    
                                </button>
                                <mat-menu #menu="matMenu">
                                    <mat-option value="Yes">.csv </mat-option>
                                    <mat-option value="No">pdf</mat-option>
                                </mat-menu> -->
                            </div>
                        </div>
                    </div>

                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="AssignVenueForm">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div *ngIf="submitButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.assign-venue.titleList.AddNewAssignVenueRecord' |
                                                    translate}}</b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                {{'header.assign-venue.titleList.AddNewAssignVenueInformation' |
                                                translate}}</p>
                                        </div>
                                        <div *ngIf="editButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.assign-venue.titleList.UpdateAssignVenueRecord' |
                                                    translate}}</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                                {{'header.assign-venue.titleList.UpdateSelectedAssignVenueInformation' |
                                                translate}}
                                            </p>
                                        </div>
                                        <div *ngIf="deleteButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.assign-venue.titleList.DeleteAssignVenueRecord' |
                                                    translate}}</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                                {{'header.assign-venue.titleList.DeleteSelectedAssignVenueInformation' |
                                                translate}}
                                            </p>
                                        </div>
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> List</mat-label>
                                                        <!-- <input matInput formControlName="" placeholder="Exam" > -->
                                                        <mat-select formControlName="AsVnlistNo" #select23
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'"
                                                                [displayMember]="'item.ListDesc'" [array]="DataList"
                                                                (filteredReturn)=" filteredDataList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredDataList"
                                                                [value]="item.EcId">
                                                                {{item.ListDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="AsVnlistNo2" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="AsVnlistNo3" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Venue</mat-label>
                                                        <input matInput formControlName="AsVnVenue1" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-3 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Valid</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="AsVnValid"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-4 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Changed</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="AsVnChng"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Roll No</mat-label>
                                                        <input matInput formControlName="AsVnRollNo" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>To</mat-label>
                                                        <input matInput formControlName="AsVnTo" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Venue</mat-label>
                                                        <input matInput formControlName="AsVnVenue2" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-12">
                                        <button type="button"
                                            class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                            *ngIf="submitButton"
                                            (click)="submit()">{{'header.assign-venue.titleList.Submit' |
                                            translate}}</button>
                                        <button type="button"
                                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                            *ngIf="editButton"
                                            (click)="update()">{{'header.assign-venue.titleList.Update' |
                                            translate}}</button>
                                        <button type="button"
                                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                            *ngIf="deleteButton"
                                            (click)="delete()">{{'header.assign-venue.titleList.Delete' |
                                            translate}}</button>
                                        <button type="button"
                                            class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                            (click)="addnewrecord('false')">{{'header.assign-venue.titleList.Back' |
                                            translate}}</button>
                                    </div>
                                    <div class="col-sm-12 pl-0">
                                        <div>
                                            <div class="table-responsive" id="table">
                                                <table class="table table-striped table-bordered text-nowrap">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th width="5%" class="f600">
                                                                Ec
                                                            </th>
                                                            <th width="5%" class="f600">
                                                                Sr. No.
                                                            </th>
                                                            <th width="10%" class="f600">
                                                                Roll No. From
                                                            </th>
                                                            <th width="40%" class="f600">
                                                                Roll No. To
                                                            </th>
                                                            <th width="10%" class="f600">
                                                                Venue
                                                            </th>
                                                            <th width="10%" class="f600">
                                                                Venue Name
                                                            </th>
                                                            <th width="10%" class="f600">
                                                                Valid
                                                            </th>
                                                            <th width="10%" class="f600">
                                                                Change
                                                            </th>
                                                            <th width="10%" class="f600">
                                                                Message
                                                            </th>
                                                            <th width="10%" class="f600">
                                                                Action
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr height="20%">
                                                            <!--  *ngFor="let data of DataList1;" -->
                                                            <td>

                                                            </td>
                                                            <td>

                                                            </td>
                                                            <td>

                                                            </td>
                                                            <td>

                                                            </td>
                                                            <td>

                                                            </td>
                                                            <td>

                                                            </td>
                                                            <td>

                                                            </td>
                                                            <td>

                                                            </td>
                                                            <td>

                                                            </td>
                                                            <td class="text-center">
                                                                <a class="btn-floating" title="Edit"
                                                                    (click)="edit('true','data')">
                                                                    <i class="fa fa-edit"></i>
                                                                </a>
                                                                <a class="btn-floating" title="Delete"
                                                                    (click)="deletee('true','exam')">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <hr>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </form>
                    </div>
                    <!-- list of Exam end  -->
                </div>
            </div>
        </div>
    </form>
</body>